export enum ReadAloudTheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}
